<template>
  <div
    class="group__info margin-top-10"
    v-if="hcDieuXeScheduleViews && hcDieuXeScheduleViews.length"
  >
    <div class="content">
      <div class="form-input">
        <div class="title font-size__small font-weight__bold margin-bottom-10">
          Thông tin xe
        </div>

        <div>
          <div class="form-input">
            <el-table
              class="table detailRelatedDocs"
              :data="hcDieuXeScheduleViews"
            >
              <el-table-column
                label="Xe"
                property="carInfo"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="Tài xế"
                property="driverInfo"
                show-overflow-tooltip
                min-width="200"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import DialogAddDocs from "../../job/create-job/dialog-add-docs";
import hcDieuXeScheduleViewService from "../../../services/hcDieuXeScheduleViewService";
import h from "../../../services/h";
import utils from "../../../services/utils";

export default {
  name: "hc-dieuxe-cars-and-drivers-readonly",
  mixins: [handleRequestErrorMixin],
  components: { DialogAddDocs },
  props: ["hcCaseMasterId"],

  data() {
    return {
      hcDieuXeScheduleViews: null
    };
  },

  watch: {
    hcCaseMasterId() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    reloadData() {
      this.loadHcDieuXeScheduleViews();
    },

    loadHcDieuXeScheduleViews() {
      return hcDieuXeScheduleViewService
        .findAllByHcCaseMasterId(this.hcCaseMasterId)
        .then(
          response =>
            (this.hcDieuXeScheduleViews = h.collect(response.data, item => {
              return {
                carInfo: `${item.licencePlate} - ${item.manufacturer}`,
                driverInfo: this.buildDriverLabel(item)
              };
            }))
        );
    },

    buildDriverLabel(item) {
      let temp_ = [];
      item.driverMobile && temp_.push(item.driverMobile);
      item.driverEmail &&
        temp_.push(
          utils.getShortString(item.driverEmail || "", { maxLength: 60 })
        );
      return temp_.length
        ? `${item.driverFullName} (${temp_.join(" - ")})`
        : `${item.driverFullName}`;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-cars-and-drivers-readonly.vue